import {useRef, useState} from "react";
import styled from "styled-components";
import ExpandLessIcon from "../icons/ExpandLessIcon/ExpandLessIcon";
import ExpandMoreIcon from "../icons/ExpandMoreIcon";
import FilterOffLineIcon from "../icons/FilterOffLineIcon";
import theme from "../../style/theme";
import {SqaureCheckBox} from "../checkbox/SquareCheckBox";
import FilterLineIcon from "../icons/FilterLineIcon";
import {getEnumValues} from "../../utils/enum/enum-util";
import {useClickOutside} from "../../utils/click/handle-click";

export enum DeliveryAssignmentStatus {
    BeforeMatched = "미배정",
    AfterMatched = "배정완료",
}

interface Props {
    onClickFilterMultiSelectItem: (value: DeliveryAssignmentStatus) => void;
    values: DeliveryAssignmentStatus[];
}

export const AssignmentMultiSelect: React.FC<Props> = (
    {
        values,
        onClickFilterMultiSelectItem,
    }
) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const handleClickBox = () => {
        setOpen(!open);
    };

    useClickOutside(ref, () => setOpen(false));

    const getSelectedItems = () => {
        if (values.length === 2) {
            return "모든 배정상태";
        }
        if (values.length === 1) {
            return `상태 : ${values[0]}`;
        }
        return "모든 배정상태";
    };

    const selectedItems = getSelectedItems();

    return (
        <div ref={ref}>
            <SelectedItem values={values} onClick={handleClickBox}>
                <LeftSelectedItemIconWrapper>
                    {values.length > 0 ? <FilterLineIcon/> : <FilterOffLineIcon/>}
                </LeftSelectedItemIconWrapper>
                <SelectedItemLabel values={values}>{selectedItems}</SelectedItemLabel>
                <RightSelectedItemIconWrapper>
                    {open ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
                </RightSelectedItemIconWrapper>
            </SelectedItem>
            {open && (
                <MenuItemList>
                    {
                        getEnumValues(DeliveryAssignmentStatus).map((assignStatus) => {
                            const isSelected = values.includes(assignStatus)

                            return (
                                <MenuItem
                                    key={assignStatus}
                                    selected={isSelected}
                                    onClick={() => onClickFilterMultiSelectItem(assignStatus)}
                                >
                                    <LeftMenuItemIconWrapper>
                                        <SqaureCheckBox
                                            checked={isSelected}
                                            fill={theme.palette.primitives.yellow400}
                                        />
                                    </LeftMenuItemIconWrapper>
                                    <MenuItemLabel>{assignStatus}</MenuItemLabel>
                                </MenuItem>
                            );
                        })
                    }
                </MenuItemList>
            )}
        </div>
    );
};

interface SelectedItemProps {
    values: string[];
}

const SelectedItem = styled.div<SelectedItemProps>`
  // width: 228px;
  height: 42px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #bec3cb;
  background-color: #ffffff;

  &:hover {
    background-color: #f5f6f9;
  }
`;

const LeftSelectedItemIconWrapper = styled.div`
  width: 36px;
  height: 42px;
  box-sizing: border-box;
  padding: 12px 8px 12px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface SelectedItemLabelProps {
    values: string[];
}

const SelectedItemLabel = styled.div<SelectedItemLabelProps>`
  // width: 228px;
  height: 42px;
  font-size: 15px;
  line-height: 18px;
  font-weight: 500;
  color: ${theme.palette.primitives.gray900};
  display: flex;
  align-items: center;
  margin-right: 12px;
`;

const RightSelectedItemIconWrapper = styled.div`
  width: 36px;
  height: 24px;
  box-sizing: border-box;
  padding: 0 12px 0 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #e0e3e9;
`;

const MenuItemList = styled.div`
  // width: 230px;
  margin: 4px 0;
  padding: 6.5px 0;
  position: absolute;
  background-color: #ffffff;
  border-radius: 8px;
  box-sizing: border-box;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
  border: solid 1px #bec3cb;
  z-index: 500;
  max-height: calc(100vh - 400px);
  overflow-y: scroll;
  overflow-x: hidden;

  /* 스크롤 바 스타일 */

  &::-webkit-scrollbar {
    width: 5px;
    background-color: #ffffff;
  }

  /* 스크롤바 색상 */

  &::-webkit-scrollbar-thumb {
    background-color: #1c2026;
    border-radius: 10px;
  }

  /* 스크롤바가 마우스 오버될 때 색상 */

  &::-webkit-scrollbar-thumb:hover {
    background-color: #bfbfbf;
  }
`;

interface MenuItemProps {
    selected: boolean;
}

const MenuItem = styled.div<MenuItemProps>`
  // width: 228px;
  height: 36px;
  display: flex;
  color: #3f444e;
  align-items: center;
  background-color: ${(props) =>
          props.selected ? theme.palette.primitives.yellow50 : "#ffffff"};

  &:hover {
    background-color: #f5f6f9;
  }

  font-size: 14px;
  font-weight: 500;
`;

const LeftMenuItemIconWrapper = styled.div`
  width: 42px;
  height: 36px;
  box-sizing: border-box;
  padding: 9px 8px 9px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MenuItemLabel = styled.div`
  // width: 228px;
  height: 42px;
  font-size: 14px;
  font-weight: 500;
  color: #3f444e;
  display: flex;
  align-items: center;
  margin-right: 25px;
`;
